import { Position } from '@xyflow/react';
import { ERFElement } from '../../../enums';
import { RECYCLE_HEX } from '../../../constants';
import { createPortCode } from '../../../utils';
export const RECYCLE_CONFIG = {
    type: ERFElement.Recycle,
    templates: [
        {
            code: 'default',
            icon: 'Recycle',
            ports: [
                {
                    id: createPortCode('target', 'recycle'),
                    type: 'target',
                    name: 'Вход',
                    position: Position.Left,
                    style: { top: 19, left: 4, background: RECYCLE_HEX },
                    connectionCount: 1
                },
                {
                    id: createPortCode('source', 'recycle'),
                    type: 'source',
                    name: 'Выход',
                    position: Position.Right,
                    style: { top: 19, right: 4, background: RECYCLE_HEX },
                    connectionCount: 1
                }
            ]
        },
        {
            code: 'filled',
            icon: 'RecycleFill',
            ports: [
                {
                    id: createPortCode('target', 'recycle'),
                    type: 'target',
                    name: 'Вход',
                    position: Position.Left,
                    style: { top: 19, left: 4, background: RECYCLE_HEX },
                    connectionCount: 1
                },
                {
                    id: createPortCode('source', 'recycle'),
                    type: 'source',
                    name: 'Выход',
                    position: Position.Right,
                    style: { top: 19, right: 4, background: RECYCLE_HEX },
                    connectionCount: 1
                }
            ]
        }
    ]
};
//# sourceMappingURL=RFRecycleNode.config.js.map